<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form/form.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('remote_code_scanning_report_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'check_detail') {
        this.formConfig = {
          ...this.formConfig,
          code: 'view',
          row,
        };
        this.modalConfig.title = '查看明细';
        this.openFull();
      }
    },
  },
};
</script>
